import React from "react";
// import ReactDOM from "react-dom";
import { Link, useLocation } from "react-router-dom";
import Slider from "react-slick";
import AnimationOnScroll from "react-animate-on-scroll";
import "animate.css/animate.min.css";
import { logAnalyticsEvent } from "../utils/analytics";
import BackArrow from "../assets/images/back-arrow.svg";
import Clock from "../assets/icons/clock1.svg";
import LocationPin from "../assets/icons/pin.svg";
import Achivment from "../assets/images/achievement.svg";
import Info from "../assets/images/info.svg";
import Detected from "../assets/images/Detected.svg";
import NotDetected from "../assets/images/NotDetected.svg";
import ImageQuality from "../assets/images/image-quality.svg";
import Nose from "../assets/images/nose.svg";
import Lighting from "../assets/images/lighting.svg";
import Faceposition from "../assets/images/face-position.svg";
import Eyeposition from "../assets/images/eye-position.svg";
import Lip from "../assets/images/lip.svg";
import Nasal from "../assets/images/nasal.svg";
import Air from "../assets/images/air.svg";
import Pollen from "../assets/images/Pollen.svg";
import PM2 from "../assets/images/pm2.svg";
import Humidity from "../assets/images/Humidity.svg";
import Temperature from "../assets/images/Temperature.svg";

const AssessmentResult = ({ state }) => {
  // const { state } = useLocation();
  const assessmentData = state?.data;

  const recommendationData = assessmentData?.recommendation;

  const isEmpty =
    !recommendationData || Object.keys(recommendationData).length === 0;

  const environmentalData = {
    aqi: assessmentData.environmental_data.aqi,
    pollenCount: assessmentData.environmental_data.pollen_count,
    pm2_5: assessmentData.environmental_data.pm2_5,
    pm10: assessmentData.environmental_data.pm10,
    humidity: assessmentData.environmental_data.humidity,
    temperature: assessmentData.environmental_data.temperature,
  };

  const symptomsData = {
    eyeRedness: assessmentData.symptoms_detected.eye_redness,
    eyePuffiness: assessmentData.symptoms_detected.eye_puffiness,
    nasalInflammation: assessmentData.symptoms_detected.nasal_inflammation,
    darkCircles: assessmentData.symptoms_detected.dark_circles,
    facialFatigue: assessmentData.symptoms_detected.facial_fatigue,
  };

  const qualityFactors = {
    imageQuality: assessmentData.image_analyis.image_quality,
    lightingQuality: assessmentData.image_analyis.lighting_quality,
    facePosition: assessmentData.image_analyis.face_position,
    visibleFeatures: assessmentData.image_analyis.visible_features,
  };
  const confidence = assessmentData.image_analyis.overall_confidence;

  const qualityItems = [
    {
      icon: ImageQuality,
      label: "Image Quality",
      value: qualityFactors.imageQuality,
      color:
        qualityFactors?.imageQuality === "good"
          ? "bg-[#69CC2B] text-white"
          : qualityFactors?.imageQuality === "fair"
          ? "bg-[#F7BE63] text-white"
          : "bg-[#E81216] text-white",
    },
    {
      icon: Lighting,
      label: "Lighting",
      value: qualityFactors.lightingQuality,
      color:
        qualityFactors?.lightingQuality === "good"
          ? "bg-[#69CC2B] text-white"
          : qualityFactors?.lightingQuality === "fair"
          ? "bg-[#F7BE63] text-white"
          : "bg-[#E81216] text-white",
    },
    {
      icon: Faceposition,
      label: "Face Position",
      value: qualityFactors.facePosition,
      color:
        qualityFactors?.facePosition === "good"
          ? "bg-[#69CC2B] text-white"
          : qualityFactors?.facePosition === "fair"
          ? "bg-[#F7BE63] text-white"
          : "bg-[#E81216] text-white",
    },
  ];

  const symptomsList = [
    {
      key: "eyeRedness",
      title: "Eye Redness",
      description:
        "Visible blood vessels or redness in the whites of the eyes.",
      icon: Eyeposition,
    },
    {
      key: "eyePuffiness",
      title: "Eye Puffiness",
      description: "Noticeable swelling or bags around the eyes",
      icon: Eyeposition,
    },
    {
      key: "nasalInflammation",
      title: "Nasal Inflammation",
      description: "Redness or swelling around the nose area",
      icon: Nasal,
    },
    {
      key: "darkCircles",
      title: "Dark Circles",
      description: "Visible darkening under the eyes",
      icon: Eyeposition,
    },
    {
      key: "facialFatigue",
      title: "Facial Fatigue",
      description: "Overall tired appearance of the face",
      icon: Nasal,
    },
  ];

  const envParams = [
    {
      key: "aqi",
      label: "Air Quality Index",
      icon: Air,
      unit: "",
      getColor: (val) => {
        if (val <= 50) return "#69CC2B";
        if (val <= 100) return "#F7BE63";
        return "#E81216";
      },
    },
    {
      key: "pollenCount",
      label: "Pollen Count",
      icon: Pollen,
      unit: "",
      getColor: (val) => {
        if (typeof val !== "string") return "#E81216";
        const level = val.toLowerCase();
        if (level === "low") return "#69CC2B";
        if (level === "moderate" || level === "medium") return "#F7BE63";
        return "#E81216";
      },
    },
    {
      key: "pm2_5",
      label: "PM2.5",
      icon: PM2,
      unit: " µg/m³",
      getColor: (val) => {
        if (val <= 30) return "#69CC2B";
        if (val <= 60) return "#F7BE63";
        return "#E81216";
      },
    },
    {
      key: "pm10",
      label: "PM10",
      icon: Pollen,
      unit: " µg/m³",
      getColor: (val) => {
        if (val <= 50) return "#69CC2B";
        if (val <= 100) return "#F7BE63";
        return "#E81216";
      },
    },
    {
      key: "humidity",
      label: "Humidity",
      icon: Humidity,
      unit: " %",
      getColor: (val) => {
        if (val >= 30 && val <= 60) return "#69CC2B";
        if ((val >= 20 && val < 30) || (val > 60 && val <= 70))
          return "#F7BE63";
        return "#E81216";
      },
    },
    {
      key: "temperature",
      label: "Temperature",
      icon: Temperature,
      unit: " °C",
      getColor: (val) => {
        if (val >= 20 && val <= 26) return "#69CC2B";
        if ((val >= 16 && val < 20) || (val > 26 && val <= 30))
          return "#F7BE63";
        return "#E81216";
      },
    },
  ];

  return (
    <section className="pt-2 flex flex-col">
      <div className="px-6 tab-screen">
        {/* <div className="flex items-center justify-between mb-8 w-full relative z-50">
          <Link
            to={-1}
            className=" w-9 h-9 bg-[#2D2D2D] rounded-full flex flex-row justify-center items-center"
          >
            <img src={BackArrow} alt="" />
          </Link>
          <h2 className="text-xl lg:text-2xl md:text-2xl font-medium text-white">
            Allergy<span className="text-secondary">Ai</span>
          </h2>
          <img src={Clock} className="w-8 h-8" alt="" />
        </div> */}

        <div className="w-full relative pb-2">
          <div className="circle-blur w-[75%] h-72 mx-auto absolute left-0 right-0 -top-7 blur-[90px]"></div>
          {/* <h1 className="text-base font-semibold text-white mb-3 relative z-50 text-center">
            Assessment Result
          </h1> */}
          <Slider
            dots
            infinite
            slidesToShow={1}
            slidesToScroll={1}
            initialSlide={0}
            autoplay
            autoplaySpeed={3000}
            className="instruction-slide"
          >
            {[
              {
                title: "Allergen Resilience Score",
                score:
                  assessmentData?.detailed_scores?.combined?.score != null
                    ? Math.round(
                        assessmentData.detailed_scores.combined.score * 10
                      )
                    : "--",
                defination:
                  "The Allergen Resilience Score (0–100) reflects your body's ability to withstand allergen triggers—100 denotes top resilience. It blends thermal mapping, nasal airflow metrics, and recent exposure history to assess your defensive response.",
              },
              {
                title: "Facial Symptom Score",
                score:
                  assessmentData?.detailed_scores?.facial?.score != null
                    ? Math.round(
                        assessmentData.detailed_scores.facial.score * 10
                      )
                    : "--",
                defination:
                  "The Facial Symptom Score evaluates visible signs of allergic rhinitis—such as redness, puffiness, and dark circles—based on facial image analysis. Higher scores indicate more prominent symptoms.",
              },
              {
                title: "Environmental Score",
                score:
                  assessmentData?.detailed_scores?.environmental?.score != null
                    ? Math.round(
                        assessmentData.detailed_scores.environmental.score * 10
                      )
                    : "--",
                defination:
                  "The Environmental Score measures allergen exposure risk based on current air quality, pollen levels, humidity, and temperature at your location. Higher scores mean higher environmental allergen presence.",
              },
            ].map((item) => (
              <div className="slider-item">
                <div className="score-card px-5 py-5 w-full">
                  <div className="flex flex-row justify-between items-center mb-3">
                    <div className="card-tittle">
                      <h4 className="text-xl font-semibold text-white leading-7">
                        {/* Allergen <br />
                      Resilience Score */}
                        {item.title}
                      </h4>
                    </div>
                    <button className="view-btn">View Details</button>
                  </div>
                  <p className=" text-xxs text-white/70 text-justify mt-1 min-h-16">
                    {item.defination}
                  </p>
                  <div className="progress-col scan-result relative mt-10 mb-1">
                    <div className="progress2 bg-gradient-to-r from-[#C81616] via-[#FFC444] to-[#64BD40]">
                      <div
                        class="progress-bar"
                        style={{ width: `${item.score}%` }}
                      >
                        <div class="progress-value">{item.score ?? "--"}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
      <div className="mt-4 px-6 pb-20 pt-5 w-full bg-white">
        <div className="tab-screen">
          <AnimationOnScroll animateIn="animate__fadeInUp" duration={0.65}>
            <h3 className="text-lg lg:text-xl md:text-xl font-medium text-primary">
              Analysis Confidence
            </h3>
          </AnimationOnScroll>
          <AnimationOnScroll animateIn="animate__fadeInUp" duration={0.65}>
            <div className="progress-col analysis-score scan-result relative mt-2 mb-1 w-11/12 mx-auto">
              <div className="flex items-center justify-between">
                <h6 className="text-xs text-[#4D6698] font-medium">
                  Overall Confidence
                </h6>
                <div className="progress-score flex flex-row items-end">
                  <p className="text-xl font-semibold text-primary">
                    {confidence}%
                  </p>
                </div>
              </div>
              <div class="progress">
                <div
                  class="progress-bar"
                  style={{ width: `${confidence}%`, background: "#41a0e1" }}
                ></div>
              </div>
              <p className="text-[8px] text-black/70 mt-1">
                <span className="font-semibold">Note:</span> Confidence score
                below 80% may impact detection accuracy.
              </p>
            </div>
          </AnimationOnScroll>
          <ul className="flex flex-row justify-between flex-wrap mt-3 mb-3">
            {qualityItems.map((item, index) => (
              <AnimationOnScroll
                className="w-[48.5%]"
                animateIn="animate__fadeInUp"
                duration={0.65}
              >
                <li key={index} className="w-full mb-3">
                  <div className="bg-[#f5f4f4]/85 rounded-[10px] p-3 flex flex-row items-center">
                    <img src={item.icon} className="w-5 h-5" alt="" />
                    <div className="ml-2">
                      <p className="text-xs font-medium text-primary mb-[3px]">
                        {item.label}
                      </p>
                      <button
                        className={`${item.color} text-xxs font-medium text-white rounded-full px-3 py-[2px]`}
                      >
                        {item.value}
                      </button>
                    </div>
                  </div>
                </li>
              </AnimationOnScroll>
            ))}
          </ul>
          <AnimationOnScroll
            className="w-[48.5%]"
            animateIn="animate__fadeInUp"
            duration={0.65}
          >
            <h4 className="text-base font-medium text-[#4D6698]">
              Visible Facial Features
            </h4>
          </AnimationOnScroll>
          <ul className="flex flex-row justify-between flex-wrap mt-3 mb-3">
            <AnimationOnScroll
              className="w-[48.5%]"
              animateIn="animate__fadeInUp"
              duration={0.65}
            >
              <li className="w-full mb-3">
                <div className="bg-[#f5f4f4]/85 rounded-[10px] p-3 flex flex-row items-center">
                  <img src={Eyeposition} className="w-5 h-5" alt="" />
                  <div className="ml-2">
                    <p className="text-xs font-medium text-primary mb-[3px]">
                      Eyes
                    </p>
                    <div
                      className={`text-xxs font-medium flex flex-row items-center ${
                        qualityFactors?.visibleFeatures?.eyes
                          ? "text-[#559F00] "
                          : "text-[#C81616]"
                      }`}
                    >
                      {qualityFactors?.visibleFeatures?.eyes ? (
                        <img src={Detected} className="w-5 h-5 mr-1" alt="" />
                      ) : (
                        <img
                          src={NotDetected}
                          className="w-5 h-5 mr-1"
                          alt=""
                        />
                      )}
                      {qualityFactors?.visibleFeatures?.eyes
                        ? "Detected"
                        : "Undetected"}
                    </div>
                  </div>
                </div>
              </li>
            </AnimationOnScroll>
            <AnimationOnScroll
              className="w-[48.5%]"
              animateIn="animate__fadeInUp"
              duration={0.65}
            >
              <li className="w-full mb-3">
                <div className="bg-[#f5f4f4]/85 rounded-[10px] p-3 flex flex-row items-center">
                  <img src={Nose} className="w-5 h-5" alt="" />
                  <div className="ml-2">
                    <p className="text-xs font-medium text-primary mb-[3px]">
                      Nose
                    </p>
                    <div
                      className={`text-xxs font-medium flex flex-row items-center ${
                        qualityFactors?.visibleFeatures?.nose
                          ? "text-[#559F00] "
                          : "text-[#C81616]"
                      }`}
                    >
                      {qualityFactors?.visibleFeatures?.nose ? (
                        <img src={Detected} className="w-5 h-5 mr-1" alt="" />
                      ) : (
                        <img
                          src={NotDetected}
                          className="w-5 h-5 mr-1"
                          alt=""
                        />
                      )}
                      {qualityFactors?.visibleFeatures?.nose
                        ? "Detected"
                        : "Undetected"}{" "}
                    </div>
                  </div>
                </div>
              </li>
            </AnimationOnScroll>
            <AnimationOnScroll
              className="w-[48.5%]"
              animateIn="animate__fadeInUp"
              duration={0.65}
            >
              <li className="w-full mb-3">
                <div className="bg-[#f5f4f4]/85 rounded-[10px] p-4 flex flex-row items-center">
                  <img src={Lip} className="w-5 h-5" alt="" />
                  <div className="ml-2">
                    <p className="text-xs font-medium text-primary mb-[3px]">
                      Mouth
                    </p>
                    <div
                      className={`text-xxs font-medium flex flex-row items-center ${
                        qualityFactors?.visibleFeatures?.mouth
                          ? "text-[#559F00] "
                          : "text-[#C81616]"
                      }`}
                    >
                      {qualityFactors?.visibleFeatures?.mouth ? (
                        <img src={Detected} className="w-5 h-5 mr-1" alt="" />
                      ) : (
                        <img
                          src={NotDetected}
                          className="w-5 h-5 mr-1"
                          alt=""
                        />
                      )}
                      {qualityFactors?.visibleFeatures?.mouth
                        ? "Detected"
                        : "Undetected"}
                    </div>
                  </div>
                </div>
              </li>
            </AnimationOnScroll>
          </ul>
          <AnimationOnScroll animateIn="animate__fadeInUp" duration={0.65}>
            <h4 className="text-base font-medium text-[#4D6698]">
              Facial Symptom Analysis
            </h4>
          </AnimationOnScroll>
          <ul className="flex flex-row justify-between flex-wrap mt-3 mb-3">
            {symptomsList.map((symptom) => {
              const detected = symptomsData[symptom.key];
              return (
                <AnimationOnScroll
                  className="w-[48.5%]"
                  animateIn="animate__fadeInUp"
                  duration={0.65}
                >
                  <li key={symptom.key} className="w-full mb-3">
                    <div className="bg-[#f5f4f4]/85 rounded-[10px] p-3 flex flex-row">
                      <img src={symptom.icon} className="w-5 h-5" alt="" />
                      <div className="ml-2">
                        <p className="text-xs font-medium text-primary mb-[3px]">
                          {symptom.title}
                        </p>
                        <p className="text-[9px] leading-[10px] font-light text-primary mb-2">
                          {symptom.description}
                        </p>
                        <button
                          className={`${
                            !detected ? "bg-[#69CC2B]" : "bg-[#E81216]"
                          } text-xxs font-medium text-white rounded-full px-2 py-[2px] flex flex-row items-center`}
                        >
                          {!detected ? (
                            <>
                              <img
                                src={Achivment}
                                className="w-3 h-3 mr-1"
                                alt=""
                              />
                              <p>Not Detected</p>
                            </>
                          ) : (
                            <>
                              <img src={Info} className="w-3 h-3 mr-1" alt="" />
                              <p>Detected</p>
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </li>
                </AnimationOnScroll>
              );
            })}
          </ul>
          <AnimationOnScroll animateIn="animate__fadeInUp" duration={0.65}>
            <h4 className="text-base font-medium text-[#4D6698]">
              Environmental Conditions
            </h4>
          </AnimationOnScroll>
          <ul className="flex flex-row justify-between flex-wrap mt-3 mb-3">
            {envParams.map((param) => {
              const value = environmentalData[param.key];
              const bgColor = param.getColor(value);

              return (
                <AnimationOnScroll
                  className="w-[48.5%]"
                  animateIn="animate__fadeInUp"
                  duration={0.65}
                >
                  <li key={param.key} className="w-full mb-3">
                    <div className="bg-[#f5f4f4]/85 rounded-[10px] p-3 flex flex-row items-center">
                      <img src={param.icon} className="w-5 h-5" alt="" />
                      <div className="ml-2">
                        <p className="text-xs font-medium text-primary mb-[3px]">
                          {param.label}
                        </p>
                        <button
                          className="text-xxs font-medium text-white rounded-full px-3 py-[2px]"
                          style={{ backgroundColor: bgColor }}
                        >
                          {value}
                          {param.unit}
                        </button>
                      </div>
                    </div>
                  </li>
                </AnimationOnScroll>
              );
            })}
          </ul>
          <AnimationOnScroll animateIn="animate__fadeInUp" duration={0.65}>
            <h4 className="text-lg font-medium text-primary mb-4 mt-2">
              Personalised Recommendations
            </h4>
          </AnimationOnScroll>
          <ul className=" list-disc pl-4">
            {Object.entries(recommendationData).map(([title, content]) => (
              <AnimationOnScroll animateIn="animate__fadeInUp" duration={0.65}>
                <li key={title} className="mb-4 text-primary text-xs">
                  <div>
                    <strong className="block text-[13px] font-semibold mb-1">
                      {title}
                    </strong>
                    <p className="text-[11px] font-light leading-snug">
                      {content}
                    </p>
                  </div>
                </li>
              </AnimationOnScroll>
            ))}
          </ul>
        </div>
      </div>

      {/* <Link to={-1} className="block mt-4 text-sm font-medium  text-white">
      Back
    </Link> */}
    </section>
  );
};

export default AssessmentResult;
